'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'

import { IBlogPostReduced } from '@/_types'

export interface ABlogPostControlsProps {
	relatedArticles: IBlogPostReduced[]
}

export default function ABlogPostControls({ relatedArticles }: ABlogPostControlsProps) {
	const router = useRouter()

	const navigateBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		router.back()
	}

	return (
		<section className='hide_lgm mb-12'>
			<div className='wrapper2 dflex justify-between'>
				<Link
					href='/clanky'
					title=''
					className='btn_basic type3 nav'
					onClick={navigateBack}
					prefetch={false}
				>
					<span>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_l'></use>
							</svg>
						</span>
						<span>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar2_l'></use>
							</svg>
						</span>
					</span>
					<span>Späť na všetky články</span>
				</Link>
				{relatedArticles?.length > 0 && (
					<Link
						href={`/clanky/${relatedArticles[0].slug}`}
						title=''
						className='btn_basic type3 nav'
						prefetch={false}
					>
						<span>Ďalší článok</span>
						<span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r'></use>
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r'></use>
								</svg>
							</span>
						</span>
					</Link>
				)}
			</div>
		</section>
	)
}
